import { getDefaultStore } from 'jotai';
import { atomWithStorage, RESET } from 'jotai/utils';

export const pccSyncNeedsReviewAlertDismissalsAtom = atomWithStorage<
  Record<string, number>
>('pccSyncNeedsReviewAlertDismissals', {}, undefined, { getOnInit: true });

export const getPccSyncNeedsReviewAlertPanelDismissalKey = (
  userId: string,
  facilityId: string
) => `${userId}:${facilityId}`;

export const resetPccSyncNeedsReviewAlertPanelDismissals = () => {
  getDefaultStore().set(pccSyncNeedsReviewAlertDismissalsAtom, RESET);
};
